import React, { PropTypes, Component } from 'react';
import Dispatcher from '../../core/Dispatcher';
import withStyles from '../../decorators/withStyles';
import styles from './LoadingSpinner.css';

@withStyles(styles)
class LoadingSpinner extends Component {
  static propTypes = {
    enabled: PropTypes.bool.isRequired,
    message: PropTypes.string
  };

  static defaultProps = {
    enabled: false
  };

  render() {
    return (
      <div className="LoadingSpinner">
        {this.props.enabled &&
            <div className="wrapper">
              <div className="inner">
                <div className="progress">
                  <div>Loading...</div>
                </div>
                <div className="description">{this.props.message}</div>
              </div>
            </div>
        }
      </div>
    );
  }
}

export default LoadingSpinner;



/** WEBPACK FOOTER **
 ** ./src/components/LoadingSpinner/LoadingSpinner.js
 **/